<template>
  <div v-if="contacts.length" class="new-chat-contacts">
    <bh-tabs-radios
      v-if="step === 1"
      v-model="toggleContactSelectionOption"
      class="mb-3"
      :values="selectionOptions"
      fullWidth
      withBg
      @input="$emit('setContactSelectionOptionIsSingle', $event === selectionOptions[0].value)"
    />
    <new-chat-contact
      v-for="contact in contacts"
      :key="`${contact.profileId}-${contact.userType}`"
      :contact="contact"
      :disable-selection="!contact.isActive && disableSelection"
      @contact:selection="$emit('contact:selection', $event)"/>
  </div>
  <div v-else class="new-chat-contacts">
    <p class="new-chat-contacts__empty">Contacts list is empty</p>
  </div>
</template>

<script>
import NewChatContact from '@/components/chat/components/NewChatContact.vue'
import BhTabsRadios from '@/components/inputs/BhTabsRadios.vue';

const selectionOptions = [
  { name: 'Direct', value: 'direct' },
  { name: 'Group', value: 'group' }
]

export default {
  name: 'NewChatContacts',
  components: {
    NewChatContact,
    BhTabsRadios
  },
  props: {
    contacts: {
      type: Array,
      default: () => []
    },
    disableSelection: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 0
    },
    contactSingleSelection: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      toggleContactSelectionOption: this.contactSingleSelection ? selectionOptions[0].value : selectionOptions[1].value,
      selectionOptions
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.new-chat-contacts {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.5 * $gutter;
  background-color: $bh-blue--4;
  overflow: hidden;
  overflow-y: auto;
  border-radius: $gutter;

  &__empty {
    text-align: center;
  }
}
</style>
